<template>
  <validation-observer ref="form" v-slot="{ valid }">
    <b-form @submit.prevent>
      <b-row class="mt-2">
        <!-- Name -->
        <b-col cols="12" lg="4">
          <b-form-group label="Nombre:" label-for="name">
            <validation-provider #default="{ errors }" name="Nombre" rules="required">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="TagIcon" />
                </b-input-group-prepend>
                <b-form-input id="name" v-model="localItem.name" placeholder="Nombre" />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Model -->
        <b-col cols="12" lg="4">
          <b-form-group label="Modelo:" label-for="model">
            <validation-provider #default="{ errors }" name="Modelo" rules="required">
              <b-input-group class="input-group-merge">
                <v-select v-model="localItem.modelId" :options="models" placeholder="Modelo" :reduce="option => option.id" label="name" autocomplete="off" class="w-100" />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- CloudId -->
        <b-col cols="12" lg="4">
          <b-form-group label="Id Nube:" label-for="cloudId">
            <b-input-group class="input-group-merge">
              <v-select v-model="localItem.cloudId" :options="cloudDevices" placeholder="Id Nube" label="cloudId" clearable autocomplete="off" class="w-100" />
            </b-input-group>
            <small class="text-danger">{{ errorCloudId }}</small>
          </b-form-group>
        </b-col>

        <!-- Site -->
        <b-col cols="12" lg="4">
          <b-form-group label="Sitio:" label-for="site">
            <validation-provider #default="{ errors }" name="Sitio" rules="required">
              <b-input-group class="input-group-merge">
                <v-select v-model="localItem.siteId" :options="sites" placeholder="Sitio" :reduce="option => option.id" label="name" clearable autocomplete="off" class="w-100" />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Interval, Lora, Enabled -->
        <b-col cols="12" lg="4">
          <b-form-group label="Intervalo (min):" label-for="interval">
            <validation-provider #default="{ errors }" name="Intervalo" rules="required">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="ClockIcon" />
                </b-input-group-prepend>
                <b-form-input id="interval" v-model="intervalInMinutes" placeholder="Intervalo" type="number" />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col cols="12" lg="4">
          <b-row>
            <!-- Lora -->
            <b-col cols="6" class="text-lg-left text-center">
              <b-form-group label="Lora:" label-for="lora">
                <b-form-checkbox id="lora" v-model="localItem.lora" switch style="margin-top: 0.5rem;" />
              </b-form-group>
            </b-col>

            <!-- Enabled -->
            <b-col cols="6" class="text-lg-left text-center">
              <b-form-group label="Habilitado:" label-for="enabled">
                <b-form-checkbox id="enabled" v-model="localItem.enabled" switch style="margin-top: 0.5rem;" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>

        <!-- Comment -->
        <b-col cols="12">
          <b-form-group label="Comentario:" label-for="comment">
            <b-input-group class="input-group-merge">
              <b-form-textarea id="comment" v-model="localItem.comment" placeholder="Comentario" />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- Info CreatedAt -->
        <b-col v-if="localItem.id > 0" cols="12" md="6">
          <b-form-group label="Creado:" label-for="createdAt">
            <b-input-group class="input-group-merge">
              <b-form-input id="createdAt" :value="$moment.utc(localItem.createdAt).local().format('DD/MM/YYYY hh:mm:ss a')" placeholder="Creado" disabled />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- Info UpdatedAt -->
        <b-col v-if="localItem.id > 0" cols="12" md="6">
          <b-form-group label="Actualizado:" label-for="updatedAt">
            <b-input-group class="input-group-merge">
              <b-form-input id="updatedAt" :value="$moment.utc(localItem.updatedAt).local().format('DD/MM/YYYY hh:mm:ss a')" placeholder="Actualizado" disabled />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- Device sensor -->
        <b-col cols="12">
          <div class="mt-1 border p-1">
            <b-overlay :show="loadingDataKey" :variant="isDarkMode ? 'dark' : 'light'" opacity="0.85" blur="2px" rounded="sm">
              <!-- title -->
              <div class="d-flex justify-content-between align-items-center">
                <h3>Sensores</h3>
                <b-button type="button" variant="outline-secondary" style="padding: 5px" @click="addSensor">
                  <feather-icon icon="PlusIcon" size="16" />
                </b-button>
              </div>
              <!-- inputs -->
              <b-row v-for="(sensor, index) in localItem.deviceData" :key="index" class="mt-2">
                <!-- name -->
                <b-col cols="12" lg="2" class="mb-1 mb-lg-0">
                  <label :for="'sensor-name-' + index">
                    <strong>Nombre</strong>
                  </label>
                  <validation-provider #default="{ errors }" name="Nombre Sensor" rules="required">
                    <b-form-input :id="'sensor-name-' + index" v-model="sensor.name" placeholder="Nombre sensor" class="form-control-sm" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <!-- type -->
                <b-col cols="12" lg="2" class="mb-1 mb-lg-0">
                  <label :for="'sensor-type-' + index" class="mb-0">
                    <strong>Tipo</strong>
                  </label>
                  <validation-provider #default="{ errors }" name="Tipo" rules="required">
                    <v-select :id="'sensor-type-' + index" v-model="sensor.sensorType" :options="dataTypes" :reduce="option => option.id" label="name" placeholder="Data" autocomplete="off" class="form-control-sm w-100" :clearable="false" @input="onSensorTypeChange($event, index)"/>
                    <small class="text-danger mt-2">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <!-- um -->
                <b-col cols="12" lg="2" class="mb-1 mb-lg-0">
                  <label :for="'sensor-um-' + index" class="mb-0">
                    <strong>UM</strong>
                  </label>
                  <validation-provider #default="{ errors }" name="UM" rules="required">
                    <v-select :id="'sensor-um-' + index" v-model="sensor.umId" :options="ums" :reduce="option => option.id" label="unit_type" placeholder="UM" autocomplete="off" class="form-control-sm w-100" :clearable="false" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <!-- Key data -->
                <b-col cols="12" lg="2" class="mb-2 mb-lg-0">
                  <label :for="'sensor-data-' + index" class="mb-0">
                    <strong>Datos</strong>
                  </label>
                  <validation-provider #default="{ errors }" name="Datos" rules="required">
                    <v-select id="input-data" v-model="sensor.data" :options="availableDataOptions(index)" placeholder="Data" multiple autocomplete="off" class="form-control-sm w-100" @input="updateSelectedDataKeys(index, $event)" :clearable="false" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <!-- default text -->
                <b-col v-if="sensor.sensorType === 'list'" cols="12" lg="1" class="mb-1 mb-lg-0">
                  <label :for="'sensor-list-default-' + index">
                    <strong>Texto neutro</strong>
                  </label>
                  <validation-provider #default="{ errors }" name="Texto neutro" rules="required">
                    <b-form-input :id="'sensor-list-default' + index" v-model="sensor.list.default" placeholder="Texto neutro" class="form-control-sm" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <!-- color, icon, enabled -->
                <b-col cols="12" lg="2" class="mb-1 mb-lg-0">
                  <b-row>
                    <!-- color -->
                    <b-col cols="4" class="d-flex flex-column align-items-center">
                      <label :for="'sensor-color-' + index">
                        <strong>Color</strong>
                      </label>
                      <input :id="'sensor-color-' + index" v-model="sensor.color" type="color" class="cursor-pointer" />
                    </b-col>
                    <!-- Icons -->
                    <b-col cols="4" class="d-flex flex-column align-items-center">
                      <label>
                        <strong>Ícono</strong>
                      </label>
                      <feather-icon :icon="sensor.icon" size="26" class="cursor-pointer"
                        @click="openIconSelectorModal(index, null, 'sensor')" />
                    </b-col>
                    <!-- enabled -->
                    <b-col cols="4" class="d-flex flex-column align-items-center">
                      <label :for="'sensor-enabled-' + index">
                        <strong>Habilitado</strong>
                      </label>
                      <b-form-checkbox :id="'sensor-enabled-' + index" v-model="sensor.enabled" name="enabled" value="true" unchecked-value="false" class="mr-1" />
                    </b-col>
                  </b-row>
                </b-col>
                <!-- actions -->
                <b-col cols="12" lg="1" class="d-none d-lg-flex align-items-center justify-content-center mb-1 mb-md-0" :class="{'align-self-center': sensor.sensorType === 'boolean'}">
                  <b-button type="button" variant="outline-danger" style="padding: 5px" @click="removeSensor(index)">
                    <feather-icon icon="MinusIcon" size="16" />
                  </b-button>
                </b-col>
                <!-- ON/OFF values for boolean type -->
                <b-col cols="12" v-if="sensor.sensorType === 'boolean'" class="mt-2">
                  <b-row class="justify-content-center">
                    <!-- ON value -->
                    <b-col cols="6" lg="2" class="mb-1 mb-lg-0">
                      <label :for="'sensor-on-value-' + index" class="text-center">
                        <strong>Valor ON</strong>
                      </label>
                      <validation-provider #default="{ errors }" name="Valor ON" rules="required">
                        <b-form-input :id="'sensor-on-value-' + index" v-model="sensor.onValue" placeholder="ON" class="form-control-sm text-center" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-col>
                    <!-- ON text -->
                    <b-col cols="6" lg="2" class="mb-1 mb-lg-0">
                      <label :for="'sensor-on-text-' + index" class="text-center">
                        <strong>Texto ON</strong>
                      </label>
                      <validation-provider #default="{ errors }" name="Texto ON" rules="required">
                        <b-form-input :id="'sensor-on-text-' + index" v-model="sensor.onText" placeholder="Texto ON" class="form-control-sm text-center" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-col>
                    <!-- ON color -->
                    <b-col cols="6" lg="2" class="mb-1 mb-lg-0 d-flex flex-column align-items-start">
                      <label :for="'sensor-on-color-' + index" class="text-center">
                        <strong>Color ON</strong>
                      </label>
                      <input :id="'sensor-on-color-' + index" v-model="sensor.onColor" type="color" class="cursor-pointer" />
                    </b-col>
                    <!-- OFF value -->
                    <b-col cols="6" lg="2" class="mb-1 mb-lg-0">
                      <label :for="'sensor-off-value-' + index" class="text-center">
                        <strong>Valor OFF</strong>
                      </label>
                      <validation-provider #default="{ errors }" name="Valor OFF" rules="required">
                        <b-form-input :id="'sensor-off-value-' + index" v-model="sensor.offValue" placeholder="OFF" class="form-control-sm text-center" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-col>
                    <!-- OFF text -->
                    <b-col cols="6" lg="2" class="mb-1 mb-lg-0">
                      <label :for="'sensor-off-text-' + index" class="text-center">
                        <strong>Texto OFF</strong>
                      </label>
                      <validation-provider #default="{ errors }" name="Texto OFF" rules="required">
                        <b-form-input :id="'sensor-off-text-' + index" v-model="sensor.offText" placeholder="Texto OFF" class="form-control-sm text-center" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-col>
                    <!-- OFF color -->
                    <b-col cols="6" lg="2" class="mb-1 mb-lg-0 d-flex flex-column align-items-start">
                      <label :for="'sensor-off-color-' + index" class="text-center">
                        <strong>Color OFF</strong>
                      </label>
                      <input :id="'sensor-off-color-' + index" v-model="sensor.offColor" type="color" class="cursor-pointer" />
                    </b-col>
                  </b-row>
                </b-col>
                <!-- multiples values for list/states type -->
                <b-col cols="12" v-if="sensor.sensorType === 'list'" class="mt-2">
                  <b-row class="mr-4">
                    <b-col cols="12" class="mb-1">
                      <div class="d-flex justify-content-between align-items-center">
                        <label class="text-start">
                          <strong>Valores</strong>
                        </label>
                        <b-button type="button" variant="outline-primary" size="sm" @click="addListValue(index)">
                          <feather-icon icon="PlusIcon" size="16" />
                        </b-button>
                      </div>
                    </b-col>
                    <b-col cols="12">
                      <div v-for="(list, listIndex) in sensor.list.list" :key="listIndex" class="d-flex align-items-center mb-1">
                        <b-col cols="3">
                          <label><strong>Valor</strong></label>
                          <validation-provider :vid="`list-key-${index}-${listIndex}`" #default="{ errors }" name="Valor ON" rules="required">
                            <b-form-input v-model="list.key" placeholder="Valor" class="form-control-sm text-center" />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                        <b-col cols="3">
                          <label><strong>Texto</strong></label>
                          <validation-provider :vid="`list-text-${index}-${listIndex}`" #default="{ errors }" name="Texto" rules="required">
                            <b-form-input v-model="list.text" placeholder="Texto" class="form-control-sm text-center" />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                        <!-- add for input time per list item -->
                        <b-col cols="1">
                          <label><strong>Tiempo (min)</strong></label>
                          <validation-provider :vid="`list-time-${index}-${listIndex}`" #default="{ errors }" name="Tiempo" rules="required">
                            <b-form-input v-model.number="list.time" placeholder="Tiempo (1 min)" class="form-control-sm text-center" type="number" />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                        <b-col cols="2" class="text-center d-flex flex-column align-items-center">
                          <label><strong>Color</strong></label>
                          <input v-model="list.color" type="color" class="cursor-pointer" />
                        </b-col>
                        <b-col cols="1" class="text-center d-flex flex-column align-items-center">
                          <label><strong>Ícono</strong></label>
                          <feather-icon :icon="list.icon" size="26" class="cursor-pointer" @click="openIconSelectorModal(index, listIndex, 'list')" />
                        </b-col>
                        <b-col cols="2" class="text-center">
                          <b-button type="button" variant="outline-danger" size="sm"
                          @click="removeState(index, listIndex)">
                          <feather-icon icon="TrashIcon" size="16" />
                        </b-button>
                      </b-col>
                    </div>
                  </b-col>
                </b-row>
                </b-col>
                <!-- actions for mobile view -->
                <b-col cols="12" class="d-lg-none mt-2 d-flex justify-content-center">
                  <b-button type="button" variant="outline-danger" style="padding: 5px" @click="removeSensor(index)">
                    <feather-icon icon="MinusIcon" size="16" />
                  </b-button>
                </b-col>
                <!-- Divider for mobile view -->
                <b-col cols="12" v-if="localItem.deviceData.length > 1">
                  <hr />
                </b-col>
              </b-row>
            </b-overlay>
          </div>
        </b-col>

        <!-- btn centered actions-->
        <b-col cols="12" class="text-center mt-2">
          <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary" @click="close">
            Cancelar
          </b-button>
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="ml-4" :disabled="loading || !valid || localItem.deviceData.length === 0" @click="save">
            <b-spinner v-if="loading" small />
            {{ loading ? 'Procesando...' : 'Guardar' }}
          </b-button>
        </b-col>
      </b-row>
      <b-modal v-model="isIconSelectorModalOpen" title="Seleccionar Ícono">
        <IconSelectorModal v-if="isIconSelectorModalOpen" @confirmIconSelection="handleIconSelected"
          @cancelIconSelection="isIconSelectorModalOpen = false" />
        <template #modal-footer>
          <b-button variant="secondary" @click="isIconSelectorModalOpen = false">
            Cancelar
          </b-button>
        </template>
      </b-modal>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BFormGroup, BFormInput, BForm, BInputGroup, BInputGroupPrepend, BRow, BCol,
  BFormTextarea, BButton, BSpinner, BFormCheckbox, BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import store from '@/store'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import IconSelectorModal from '@/views/utils/IconSelectorModal.vue'
import allFetchData from './allFetchData'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BFormTextarea,
    BButton,
    BSpinner,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    FeatherIcon,
    IconSelectorModal,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  setup() {
    const { dataTypes, fetchLastIotData, loading: loadingDataKey } = allFetchData()

    return {
      dataTypes,
      fetchLastIotData,
      loadingDataKey,
    }
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    models: {
      type: Array,
      default: () => [],
    },
    sites: {
      type: Array,
      default: () => [],
    },
    ums: {
      type: Array,
      default: () => [],
    },
    cloudDevices: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      required,
      errorCloudId: '',
      localItem: JSON.parse(JSON.stringify(this.item)),
      itemSensor: {
        name: '',
        umId: '',
        sensorType: 'number',
        onValue: '',
        onText: '',
        onColor: '#c81919',
        offValue: '',
        offText: '',
        offColor: '#000000',
        list: {
          list: [],
        },
        data: [],
        color: '#000000',
        icon: 'ActivityIcon',
        enabled: true,
      },
      isIconSelectorModalOpen: false,
      selectedSensorIndex: null,
      selectedListIndex: null,
      selectedIconType: null,
    }
  },
  computed: {
    isDarkMode() {
      return store.state.appConfig.layout.skin === 'dark'
    },
    intervalInMinutes: {
      get() {
        return this.localItem.timeInterval / 60;
      },
      set(value) {
        this.localItem.timeInterval = value * 60;
      }
    }
  },
  watch: {
    'localItem.cloudId': {
      handler(newValue, oldValue) {
        this.errorCloudId = ''
        this.getDataKeys(oldValue, newValue)
      },
      immediate: true,
    },
    item: {
      handler(newVal) {
        this.localItem = JSON.parse(JSON.stringify(newVal))
      },
      deep: true,
    },
  },
  methods: {
    save() {
      if (this.localItem.cloudId === null || this.localItem.cloudId === undefined || this.localItem.cloudId === '') {
        this.errorCloudId = 'El campo Nube Id es requerido'
        return
      }
      this.$refs.form.validate().then(success => {
        if (success) {
          this.$emit('save', this.localItem)
        }
      })
    },
    close() {
      this.$emit('close')
    },
    updateSelectedDataKeys(index, newValues) {
      this.$set(this.localItem.deviceData[index], 'data', newValues)
    },
    openIconSelectorModal(index, listIndex, type) {
      this.isIconSelectorModalOpen = true
      if(type === 'sensor'){
        this.selectedIconType = 'sensor'
        this.selectedSensorIndex = index
      }else if (type === 'list'){
        this.selectedIconType = 'list'
        this.selectedSensorIndex = index
        this.selectedListIndex = listIndex
      }
      
    },
    handleIconSelected(icon) {
      const index = this.selectedSensorIndex
      const list = this.selectedListIndex

      if (index !== null && index >= 0 && index < this.localItem.deviceData.length) {
        if(this.selectedIconType === 'sensor'){
          this.localItem.deviceData[index].icon = icon
        }else if (this.selectedIconType === 'list'){
          this.localItem.deviceData[index].list.list[list].icon = icon
        }
      }
      this.isIconSelectorModalOpen = false
    },
    async getDataKeys(oldValue, newValue) {
      if (oldValue !== newValue && newValue !== null) {
        this.loadingDataKey = true
        this.fetchLastIotData(newValue, res => {
          this.localItem.iotData = Object.keys(res.data)
          this.loadingDataKey = false
          if (oldValue !== undefined) {
            this.localItem.deviceData.forEach(sensor => {
              this.$set(sensor, 'data', [])
            })
          }
        })
      }
    },
    addSensor() {
      if (this.localItem.deviceData.length < this.localItem.iotData.length) {
        this.localItem.deviceData.push(JSON.parse(JSON.stringify(this.itemSensor)))
      } else {
        this.$bvToast.toast('No se pueden agregar más sensores. Todas las opciones de datos están en uso.', {
          title: 'Límite alcanzado',
          variant: 'warning',
          solid: true,
        })
      }
    },
    removeSensor(index) {
      this.localItem.deviceData.splice(index, 1)
    },
    availableDataOptions(index) {
      if (!this.localItem.iotData) return []
      const selectedData = this.localItem.deviceData.reduce((acc, sensor, i) => {
        if (i !== index) {
          acc.push(...sensor.data)
        }
        return acc
      }, [])
      return this.localItem.iotData.filter(option => !selectedData.includes(option))
    },
    onSensorTypeChange(value, index) {
      if(value==='list'){
        this.addListValue(index)
      }
    },
    addListValue(index) {
      const newItem = {
        key: '',
        text: '',
        icon: 'ActivityIcon',
        color: '#000000',
        time: 0
      };
      if (this.localItem.deviceData[index].list.list.length === 0) {
        this.localItem.deviceData[index].list.list.push(newItem);
      } else {
        this.localItem.deviceData[index].list.list.push(newItem);
      }
    },
    removeState(index, listIndex) {
      this.localItem.deviceData[index].list.list.splice(listIndex, 1)
    }
  },
}
</script>